import React, { useEffect, useState, useContext } from "react";
import PropTypes from "prop-types";
import { useMsal } from "@azure/msal-react";
import { Box, Typography } from "@mui/material";
import PrimaryTextField from "../../../Inputs/PrimaryTextField/PrimaryTextField";
import { CarrierService } from "../../../../services/CarrierService";
import { AlertContext } from "../../../Dashboard/Dashboard";

export default function CarrierProfileEquipmentItem({ 
  equipment, 
  disabled,
  handleDeleteEquipment,
  setDisableAll
}) {
  const { instance } = useMsal();
  const [count, setCount] = useState("");
  const [countChanged, setCountChanged] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const { warning } = useContext(AlertContext);

  const handleUpdate = () => {
    if (countChanged) {
      setIsUpdating(true);

      if (!count || count === "" || count === "0") { 
        setDisableAll(true);     
        CarrierService.DeleteCarrierEquipment(instance, equipment.id).then(() => {
          setIsUpdating(false);
          setDisableAll(false);
          handleDeleteEquipment(equipment);
        }).catch(error => {
          console.error(error);
          setDisableAll(false);
          setIsUpdating(false);
          warning(error);
        });
      } else {
        const payload = equipment;
        equipment.equipmentCount = count;

        CarrierService.UpdateCarrierEquipment(instance, payload).then(() => {
          setIsUpdating(false);
          setCountChanged(false);
        }).catch(error => {
          console.error(error);
          setIsUpdating(false);
          setCountChanged(false);
          warning(error);
        });
      }
    }
  };

  const handleChange = (e) => {
    setCount(e);
    setCountChanged(true);
  };

  useEffect(() => {
    setCount(equipment.equipmentCount);
  }, [equipment]);

  return (
    <Box sx={{ display: "flex", alignItems: "center", marginTop: "16px" }}>
      <PrimaryTextField 
        id={`carrier-equipment-value-${equipment?.equipmentTypeName}`}
        width="56px"
        value={count}
        disabled={disabled || isUpdating}
        onBlur={handleUpdate}
        onChange={(event) => handleChange(event)}
        onEnter={handleUpdate}
      />
      <Typography variant="body1" color="black_opacity.100" sx={{ marginLeft: "8px" }}>
        {equipment?.equipmentTypeName}
      </Typography>
    </Box>
  );
}

CarrierProfileEquipmentItem.propTypes = {
  equipment: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  handleDeleteEquipment: PropTypes.func,
  setDisableAll: PropTypes.func
};